import { WCBaseComponent } from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <dl class="wc-list-dl m-0 mb-1">
    <dt class="wc-list-dt m-0 informacao text-gray-600 fw-lighter small"></dt>
    <dd class="wc-list-dd m-0"></dd>
  </dl>
`;

export class WCListDl extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListDl = clone.content.querySelector('.wc-list-dl').cloneNode(false);
    let wcListDt = document.createElement('wc-list-dt');
    let wcListDd = document.createElement('wc-list-dd');
    let dataCaption = this.getAttribute('data-caption');
    let dataIcon = this.getAttribute('data-icon');
    wcListDt.append(document.createTextNode(dataCaption));
    wcListDl.append(wcListDt);
    if (dataIcon !== null) {
      let wcIcon = document.createElement('i');
      wcIcon.setAttribute('class', dataIcon);
      wcListDd.append(wcIcon, document.createTextNode(' '));
    }
    if (contentNodes.length > 0) {
      contentNodes.forEach(node => {
        wcListDd.append(node);
      });
    } else {
      let dataContent = this.getAttribute('data-content');
      let dataLink = this.getAttribute('data-link') !== null ? this.getAttribute('data-link') : false;
      if (dataLink && dataContent !== '-') {
        let elementAnchor = document.createElement('a');
        elementAnchor.href = dataContent;
        elementAnchor.target = '_blank';
        elementAnchor.append(dataContent);
        wcListDd.append(elementAnchor);
      } else {
        wcListDd.append(document.createTextNode(dataContent));
      }
    }
    wcListDl.append(wcListDd);
    // this.innerHTML = '';
    this.replaceWith(wcListDl);
  }

}

export class WCListDt extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListDt = clone.content.querySelector('.wc-list-dt').cloneNode(false);
    contentNodes.forEach(node => {
      wcListDt.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListDt);
  }

}

export class WCListDd extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListDd = clone.content.querySelector('.wc-list-dd').cloneNode(false);
    contentNodes.forEach(node => {
      wcListDd.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListDd);
  }

}